module.exports = __webpack_public_path__ + "assets/img/buzhou_tianjia@2x.86a36ace.png";